import { extendObservable } from "mobx";
// updates existing properties on an object and turn into observable those that don't exist.
// usage BindDataToStore(store, extraData1, extraData2, ...)
// Keep in mind that extendObservable doesn't work for nested objects, nor does this function.
// TODO (later) we should ignore extra properties that do not belong to the class with observable
// properties (Store or Model)
function BindDataToStore(...args) {
  const [store, ...remaining] = args;
  const extendable = {};

  for (let i = 0; i < remaining.length; i += 1) {
    const data = remaining[i];
    const keys = Object.keys(data);

    for (let j = 0; j < keys.length; j += 1) {
      const key = keys[j];

      if (typeof store[key] === "undefined") {
        // This property doesn't exists in the store, will add it to the extendable object
        // and let extendObservable to take care of all the properties at once
        extendable[key] = data[key];
      } else {
        // If the property exists in the store, then let's update it right away.
        store[key] = data[key];
      }
    }
  }

  if (Object.keys(extendable).length > 0) {
    extendObservable(store, extendable);
  }
}

export default BindDataToStore;
